<template>
  <ModalContainer queryParam="tirilla" size="lg">
    
    <b-card class="mb-0">

      <GeneralLoader v-if="isLoading"/>

      <div v-if="!isLoading">
        <h4 class="text-center">Agregar tirilla</h4>

        <div class="my-1" v-if="dataPaciente">
          <p><b>Paciente: {{ dataPaciente.nombre }}</b> </p>
        </div>

        <div class="p-2" style="border: 1px solid #ccc; border-radius: 5px" >
          <LoadFileInput
            v-model="tirillaFile"
            label="Tirilla"
            :urlFile="urlTirilla"
          />
        </div>
        

        <div class="mt-3 d-flex justify-content-end">
          <b-button 
            variant="primary" 
            @click="onSaveTirilla"
          >
            Guardar
          </b-button>
        </div>
      </div>
    </b-card>
    
  </ModalContainer>
  
</template>

<script>

import { fileService } from '@/shared/services';
import axios from 'axios';
import rutas from '@/assets/utils/rutas.json';
import { ModalContainer, LoadFileInput, GeneralLoader } from '@/shared/components';
import { derivacionesService } from '@/views/derivaciones/services';

export default {

  components: {
    ModalContainer,
    LoadFileInput,
    GeneralLoader
  },


  created() {
    this.loadData();
  },

  data() {
    return {
      tokenDerivacion: null,
      dataPaciente: null,
      dataDerivacion: null,

      isLoading: false,

      tirillaFile: null,
      urlTirilla: null
    }
  },

  methods: {

    async loadData(){

      this.isLoading = true
      
      this.tokenDerivacion = this.$route.query.tirilla;

      if(!this.tokenDerivacion) return;

      const dataDerivacion = await derivacionesService.getByToken(this.tokenDerivacion)
      const dataPaciente = dataDerivacion.atenmedId.cita.paciente.persona;

      this.dataPaciente = {
        identificacion: dataPaciente.identificacion,
        nombre: `${dataPaciente.identificacion} - ${dataPaciente.primerApellido} ${dataPaciente.primerNombre}`
      }

      this.dataDerivacion = dataDerivacion;
      this.urlTirilla = dataDerivacion.urlTirillaDerivacion;
      this.isLoading = false
    },
    

    async onSaveTirilla() {
      if(!this.tirillaFile) return;

      const urlTirilla = await fileService.upload('tirillaDerivacion', this.tirillaFile, this.dataPaciente.identificacion);
      const subirTirilla  = await this.subirTirilla(this.dataDerivacion.id, urlTirilla)

      if(!subirTirilla){
        await this.$swal({
          title: 'Error',
          text: 'Error al subir tirilla',
          icon: 'error',
          confirmButtonColor: '#089599'
        });

        return;
      }

      await this.$swal({
        title: 'Éxito',
        text: 'Éxito al subir tirilla',
        icon: 'success',
        confirmButtonColor: '#089599'
      });

      this.$router.go(0)
    },

    async subirTirilla(derivacionId, urlTirilla) {
      
      const query = `
        mutation MyMutation(
          $idDerivacion: ID!, 
          $urlTirillaDerivacion: String!
        ) {
          subirTirillaDerivacion(
            idDerivacion: $idDerivacion, 
            urlTirillaDerivacion: $urlTirillaDerivacion
          ) {
            status
            message
            derivacion {
              id
            }
          }
        }
      `;
      const variables = {
        idDerivacion: derivacionId,
        urlTirillaDerivacion: urlTirilla
      }

      try {
        const response = await axios.post(rutas.axios + "api", { query, variables });
        if (response.status !== 200) return null;

        const response2 = response.data.data.subirTirillaDerivacion;
        if (response2.status !== 'success') return null;

        const data = response2?.derivacion;
        return data;
        
      } catch (error) {
        console.error("Error", error);
        return null;
      }
    },
  },


  watch: {
    '$route.query.tirilla':{
      deep: true,
      handler(newValue){
        if(!newValue) return;
        this.loadData();
      }
    }
  }
}
</script>